import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MenuItem, MessageService} from 'primeng/api';
import {
    BookingRef,
    CargoDetails,
    InvolvedParty,
    Shipment,
    ShipmentVesselInfo,
    TranshipmentInfo
} from '../@shared/models/shipment-details.model';
import * as _ from 'lodash';
import {CommonService} from "../@shared/services/common.service";
import {BookingService} from '../@shared/new-services/booking.service';


@Component({
    selector: 'app-shipment-details',
    templateUrl: './shipment-details.component.html',
    styleUrls: ['./shipment-details.component.scss']
})
export class ShipmentDetailsComponent implements OnInit {

    bookingId: string;
    bookingGid: string;
    items: MenuItem[] = [];
    home: MenuItem = {icon: 'pi pi-home', routerLink: '/booking-summary'};
    shipmentDetails: any[] = [];
    bookingRef: BookingRef[];
    involvedParty: InvolvedParty[];
    shipment: Shipment[];
    vessel: ShipmentVesselInfo[];
    transhipment: TranshipmentInfo[];
    cargo: CargoDetails[];
    shipmentType: any;
    isLoading = false;
    blNumbers: any;
    selectedBlNumber: any;
    movementType: any;
    screenSize = window.innerWidth;

    constructor(private activatedRoute: ActivatedRoute,
                private commonService: CommonService,
                private messageService: MessageService,
                private bookingService: BookingService) {
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (params) {
                this.bookingId = params.bookingId;
                this.shipmentType = params.shipmentType;
                this.movementType = params.movementType;
                this.bookingGid = params.bookingGid;
                this.items = [
                    {label: 'Booking Summary', icon: '', routerLink: '/booking-summary'},
                    {label: 'Shipment Details : ' + this.bookingId}
                ];
                this.getBlNumbersByBookingId(this.bookingGid);
            }
        });
    }

    dataTypeOf(value) {

        if (Object.prototype.toString.call(value) === '[object Date]') {
            return 'date';
        }
        return typeof value;
    }

    getShipmentDetails(bookingId: string, blNumber?: string) {
        this.shipmentDetails = null;
        this.isLoading = true;
        this.bookingService
            .getShipmentDetails(bookingId, blNumber)
            .subscribe(
                (x) => {
                    x = x ? JSON.parse(x?.builtValues) : null;
                    const sortedArray = _.sortBy(x, 'serialNumber');
                    this.shipmentDetails = sortedArray;
                    // tslint:disable-next-line:no-shadowed-variable
                    this.shipmentDetails?.map((x) => {
                        const sortedColumns = _.sortBy(x?.columns, 'sequenceNumber');
                        x?.toString().length > 0 ? x.columns = sortedColumns : '';
                    });
                    this.isLoading = false;
                }, error => {
                    this.isLoading = false;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Shipment Details Error !',
                        detail: error?.message ? error?.message : error,
                        key: 'shipment-details'
                    });
                });

    }


    getBlNumbersByBookingId(bookingGid: string) {
        this.isLoading = true;
        this.commonService
            .getBlNumbersByBookingId(bookingGid)
            .subscribe(
                (x) => {
                    this.isLoading = false;

                    this.blNumbers = x;
                    this.selectedBlNumber = this.blNumbers[0];
                    this.getShipmentDetails(bookingGid, this.blNumbers[0]);
                    // this.getShipmentDetails(this.bookingGid, this.selectedBlNumber);


                }, (error) => {
                    this.isLoading = false;
                    this.getShipmentDetails(bookingGid, null);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'BL Number Error !',
                        detail: error?.message ? error?.message : error,
                        key: 'shipment-details'
                    });
                }
            );
    }

    onChangeOfBlNumber(data?: any) {
        const blNumber = data?.value;
        this.selectedBlNumber = blNumber;
        this.getShipmentDetails(this.bookingId, blNumber);
    }

}
